export const invoices = {
    namespaced: true,
    state: {
        invoiceList: [],
        isLoading: false
    },
    mutations: {
        SET_INVOICE_LIST(state, payload) {
            state.invoiceList = payload
        },
        SET_IS_LOADING(state, payload) {
            state.isLoading = payload
        }
    },
    actions: {
        async fetchInvoices({ commit }) {
            commit('SET_IS_LOADING', true)
            try {
                const response = await this.$api.get('api/client-invoices')
                commit('SET_INVOICE_LIST', response.data.data)
            } catch(error) {
                throw Error(error)
            } finally {
                commit('SET_IS_LOADING', false)
            }
        }
    },
    getters: {
        invoiceList: state => state.invoiceList,
        isLoading: state => state.isLoading
    }
}
